import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import ReferenceForm from '../modules/ReferenceForm';

class NewReferencePage extends Component {
  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  getInitialValues = () => {
    const initialValues = { sheaderImage: {} };
    const { state } = this.props.location;
    if (!state) {
      return initialValues;
    } else {
      return { ...initialValues, lang: state.lang };
    }
  };

  render() {
    return (
      <Layout>
        <Container>
          <h1>Nová služba</h1>
          <ReferenceForm
            config={this.getConfig()}
            initialValues={this.getInitialValues()}
          />
        </Container>
      </Layout>
    );
  }
}

export default NewReferencePage;



// WEBPACK FOOTER //
// ./src/pages/NewReferencePage.js